import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";

const Selffeedback = () => {
  const [feedback, setFeedback] = useState<any[]>([]);
  const [financialYear, setFinancialYear] = useState("");

  const {
    data: feedbackData,
    error,
    callApi: fetchEmployees,
  } = useApi("/api/monthly-feedback-finyear", {
    method: "POST",
    autoCall: false,
  });

  // Set current financial year by default
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    const fyStartYear = month >= 4 ? year : year - 1;
    setFinancialYear(`${fyStartYear}-${String(fyStartYear + 1).slice(-2)}`);
  }, []);

  // Fetch data whenever FY changes
  useEffect(() => {
    if (!financialYear) return;

    fetchEmployees({
      financial_year: financialYear,
    });
  }, [financialYear]);

  // Update table data
  useEffect(() => {
    if (feedbackData?.success) {
      setFeedback(feedbackData?.data || []);
    }
  }, [feedbackData]);

  const monthNames: any = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  const columns2 = [
    {
      title: "S No.",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Month",
      dataIndex: "feedback_month",
      key: "feedback_month",
      render: (month: number) => monthNames[month] || month,
      sorter: (a: any, b: any) => a.feedback_month - b.feedback_month,
    },
    {
      title: "Feedback",
      dataIndex: "feedback",
      key: "feedback",
      sorter: (a: any, b: any) =>
        (a.feedback || "").localeCompare(b.feedback || ""),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Heading */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Monthly Feedback</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Monthly Feedback</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Monthly Feedback
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Main Card */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
              <h5 className="mb-0">Feedback List</h5>

              {/* Financial Year Dropdown */}
              <div style={{ minWidth: "180px" }}>
                <select
                  className="form-select"
                  value={financialYear}
                  onChange={(e) => setFinancialYear(e.target.value)}
                >
                  {(() => {
                    const currentYear = new Date().getFullYear();

                    return Array.from({ length: 3 }, (_, i) => {
                      const year = currentYear - 1 + i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const fy = `${year}-${nextYearShort}`;

                      return (
                        <option key={fy} value={fy}>
                          {fy}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
            </div>

            <div className="card-body">
              {error && (
                <div className="alert alert-danger">
                  Failed to load feedback data.
                </div>
              )}

              <div className="card table-responsive">
                <Table
                  dataSource={feedback}
                  columns={columns2}
                  Selection={false}
                  showSearchInput={true}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default Selffeedback;
